import { Splide } from '@splidejs/splide';

export default () => {
	const sections = document.querySelectorAll('.insta');
	const url = 'https://instafeed.nfcube.com/feed/v4?charge=0&fu=0&limit=5&account=serenabute.myshopify.com&fid=0&hash=a26a6ec8dba0a2bfb85e8db00023b060';
	const LIST_SELECTOR = '.insta .splide__list';

	if (sections.length == 0) {return}
	getData(url).then(data => {
		// console.log(data);

		let html = buildHtml(data);
		insertHtml(html);
		initSliders();
	});


	function initSliders() {
		sections.forEach(function(section) {
			const slider = section.querySelector('.splide');

			if (slider) {
				const splide = new Splide(slider, {
					focus  : 'center',
					gap: 12,
					speed: 500,
					arrows: false,
					pagination: false,
					type: 'loop',
					autoWidth: true,
					mediaQuery: 'min',
					drag: 'free',
					breakpoints: {
						744: {
							gap: 20
						},
						1024: {
							destroy: true,
						},
					}
				}).mount();
			}
		});
	};


	function getData(url) {
		return fetch(url)
			.then(response => response.json())
			.then(data => data);
	}

	function insertHtml(html) {
		const list = document.querySelector(LIST_SELECTOR);
		list.innerHTML = html;
	}

	function buildHtml(data) {
		let html = '';

		data.data.forEach((item, index) => {
			html += `
				<div class="insta__col insta__col--${index % 2 == 0 ? 'narrow' : 'wide'} splide__slide">
					<div class="insta__item">
						<a href="${item.link}" class="insta__item-link" target="_blank"></a>
						<img src="${item.images.standard_resolution.url}" alt="${item.caption.text}" class="insta__item-img" loading="lazy">
					</div>
				</div>
			`;
		});
		return html;
	}
}